import { useIsCurrentUserPermittedTo } from "PFCore/helpers/use_is_permitted_to";
import { PermissionRule } from "PFTypes";
import { Activity } from "PFTypes/activity";

export const useIsShortlistingPermitted = () => {
  const isPermittedToShortlist = useIsCurrentUserPermittedTo(PermissionRule.ShortlistWithoutOwnership);

  return (activity?: Pick<Activity, "coowned">): boolean => !!activity?.coowned || isPermittedToShortlist;
};
